import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AddressService } from 'src/app/modules/address/service/address/address.service';
import { countryReference } from '../../../utils/constants/strings';
import { getCountryNameByCountryCode, postalCodePatternValidation } from '../../../utils/utils';
import { basicSnackBarConfig } from '../../../utils/default-configs/configuration';
import { SnackBarService } from '../../../shared/snack-bar/services/snack-bar.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { BehaviourService } from 'src/app/shared/services/behaviour.service';
import { AddressEmailAlertComponent } from '../address-email-alert/address-email-alert.component';
import { DexieDbService } from 'src/app/shared/services/dexie-db.service';

@Component({
  selector: 'app-create-address',
  templateUrl: './create-address.component.html',
  styleUrls: ['./create-address.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class CreateAddressComponent implements OnInit {
  addressDetailsForm: FormGroup;
  formType = 'Create';
  isShipper: boolean = false;
  isReceiver: boolean = false;
  currentPageFrom: number = 0;
  addressID;
  addressUniqueId: string = '';
  addressData;
  addressTypes = ['RECEIVER', 'SHIPPER', 'SELLER', 'BUYER'];
  CountryCode: string;
  list = countryReference;
  isAddressValidated: boolean = true;
  filteredCountry = countryReference;
  cityList = [];
  isPostalCodeReq: boolean;
  isPostalCodeValid: boolean = true;
  isCityValid: boolean = true;
  isDefaultAddress: boolean;
  showEmailAdd: boolean;
  configId: string;
  validPostalCodeCityname: string;
  businessLabel: string;
  businessTypeVal: string;
  constructor(
    private fb: FormBuilder,
    private addressService: AddressService,
    private configService: ConfigService,
    private errorDialogService: ErrorDialogService,
    private snackBarService: SnackBarService,
    private behaviourService: BehaviourService,
    private dialogRef: MatDialogRef<any>,
    private dialog: MatDialog,
    private dexieDbService: DexieDbService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      addressId: string;
      currentIndex: number;
      _id: string;
      _defaultShipperAddresVal: string;
      _configId: string;
      openedFrom: string;
      sellerCount: number;
      buyerCount: number;
    }
  ) {}

  ngOnInit(): void {
    this.getDetailsFromAddressList();
    this.formType = this.data?.openedFrom;
    if (this.formType === 'addParties') {
      this.addressTypes = this.addressTypes.filter(item => ['SELLER', 'BUYER'].includes(item));
    } else {
      this.addressTypes = this.addressTypes.filter(item => !['SELLER', 'BUYER'].includes(item));
    }

    this.addressDetailsForm.get('address_type')?.valueChanges.subscribe(value => {
      if (value === 'SELLER') {
        this.businessLabel = 'address.createAddress.shippingFromBusiness';
        this.businessTypeVal = 'SELLER';
      } else if (value === 'BUYER') {
        this.businessLabel = 'address.createAddress.shippingToBusiness';
        this.businessTypeVal = 'BUYER';
      }
    });
  }

  getDetailsFromAddressList() {
    this.configId = this.data?._configId;
    this.addressID = this.data?.addressId;
    this.addressUniqueId = this.data?._id;
    this.currentPageFrom = this.data?.currentIndex;
    if (
      this.data?._defaultShipperAddresVal &&
      this.data?._defaultShipperAddresVal === this.addressID
    ) {
      this.isDefaultAddress = true;
    }
    if (this.addressID) {
      this.formType = 'Update';
      this.getAddressWithId();
    }
    this.intialiseAddressFormGroup();

    this.countrySearchInitialise();
    this.citySearchInitialise();
    this.pinCodeSearchInitialise();
  }

  countrySearchInitialise() {
    this.addressDetailsForm.controls.address_details
      .get('CountryName')
      .valueChanges.subscribe(newValue => {
        this.list = this.filteredCountry.filter(
          value => value?.name.toLowerCase().indexOf(newValue.toLowerCase()) === 0
        );
      });
  }

  citySearchInitialise() {
    this.addressDetailsForm.controls.address_details
      .get('CityName')
      .valueChanges.pipe(debounceTime(1500), distinctUntilChanged())
      .subscribe(newValue => {
        const currCity = this.cityList.some(con => con.city == newValue.trim());
        if (!currCity) {
          if (newValue.trim().length >= 3) {
            this.addressService
              .getPostalCodeServiceableArea(
                this.addressDetailsForm.get('address_details').get('CountryCode').value,
                newValue.trim(),
                ''
              )
              .subscribe((response: any) => {
                this.cityList = response?.postalLocationList;

                if (this.cityList.length > 0) {
                  if (this.addressDetailsForm.get('address_details').get('CityName').value != '') {
                    this.isCityValid =
                      this.cityList.some(con => con.city == newValue.trim().toUpperCase()) ||
                      this.validPostalCodeCityname.trim().toUpperCase() ==
                        newValue.trim().toUpperCase();
                  }
                } else {
                  this.isCityValid = false;
                }
              });
          }
        } else {
          this.isCityValid = true;
        }
      });
  }

  pinCodeSearchInitialise() {
    this.addressDetailsForm.controls.address_details
      .get('PostalCode')
      .valueChanges.pipe(debounceTime(1500), distinctUntilChanged())
      .subscribe(newValue => {
        if (
          this.addressDetailsForm.get('address_details').get('CountryCode').value == 'CA' ||
          this.addressDetailsForm.get('address_details').get('CountryCode').value == 'GB'
        ) {
          newValue = postalCodePatternValidation(
            this.addressDetailsForm.get('address_details').get('CountryCode').value,
            newValue
          );
        }
        const currPostalCode = this.cityList.some(con => con.postalCode == newValue.trim());
        if (!currPostalCode && this.isPostalCodeReq) {
          if (newValue.trim().length >= 3) {
            this.addressService
              .getPostalCodeServiceableArea(
                this.addressDetailsForm.get('address_details').get('CountryCode').value,
                '',
                newValue.trim()
              )
              .subscribe((response: any) => {
                this.cityList = response?.postalLocationList;

                if (this.cityList.length > 0) {
                  if (
                    this.isPostalCodeReq &&
                    this.addressDetailsForm.get('address_details').get('PostalCode').value != ''
                  ) {
                    this.isPostalCodeValid = this.cityList.some(
                      con => con.postalCode == newValue.trim()
                    );
                  }
                } else {
                  this.isPostalCodeValid = false;
                }
                if (this.isPostalCodeValid) {
                  this.validPostalCodeCityname = this.cityList.find(
                    con => con.postalCode == newValue.trim()
                  ).city;
                }
              });
          }
        } else {
          this.isPostalCodeValid = true;
          this.cityList = this.cityList.filter(value => value?.postalCode?.indexOf(newValue) === 0);
        }
      });
  }

  getAddressWithId() {
    const addressReq = {
      query: {
        address_id: [this.addressID],
      },
    };
    this.addressService.getAddressList(addressReq).subscribe({
      next: data => {
        this.patchDataWithForm(data.data.find(item => item?._id === this.addressUniqueId));
        const currCountryCode = data.data[0].address_details.CountryCode;
        this.isAddressValidated = data.data[0].address_validated;
        this.isShipper = this.verifyIsShipper(data.data);
        this.isReceiver = this.verifyIsReceiver(data.data);
        if (currCountryCode) {
          this.isPostalCodeReq = this.list.find(
            con => con.code === currCountryCode
          ).isPostalCodeServiceAvailable;
        }
        if (!this.isPostalCodeReq) {
          this.addressDetailsForm.get('address_details').get('PostalCode').setValue('');
          this.addressDetailsForm.get('address_details').get('PostalCode').disable();
        }
      },
    });
  }

  verifyIsShipper(response) {
    return response[0]?.address_type === 'SHIPPER';
  }

  verifyIsReceiver(response) {
    return response[0]?.address_type === 'RECEIVER';
  }

  patchDataWithForm(val) {
    const addressString = this.getAddressTypeString(val.address_type);
    const keys = Object.keys(val.address_details);
    const result = {};

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      result[key.replace(addressString, '')] = val.address_details[key];
    }

    const preAlertEmailsData = val.preAlertEmails;
    if (preAlertEmailsData != undefined && preAlertEmailsData.length > 0) {
      (this.addressDetailsForm.get('preAlertEmails') as FormArray).clear();
      if (preAlertEmailsData.length > 0) {
        preAlertEmailsData.forEach(alertMsg => {
          const alertMsgGrp = this.newPreAlertMsg();
          alertMsgGrp.patchValue(alertMsg);
          (this.addressDetailsForm.get('preAlertEmails') as FormArray).push(alertMsgGrp);
        });
      }
    }

    val.address_details = result;

    this.addressData = val.address_details;

    this.addressDetailsForm.patchValue(val);

    this.addressDetailsForm.patchValue({ _id: val._id });
    this.addressDetailsForm.patchValue({ shipmentNotification: val.shipmentNotification });
    this.showEmailAdd = val.shipmentNotification;
    this.addressDetailsForm.controls.address_details.patchValue({
      CountryName: getCountryNameByCountryCode(this.addressData?.CountryCode).name,
    });

    this.addressDetailsForm.get('address_details').get('NickName').disable();
    this.addressDetailsForm.get('address_type').disable();
  }

  getAddressTypeString(value) {
    let addressString;
    switch (value) {
      case 'MOTHER_RECEIVER':
        addressString = 'receiver';
        break;
      case 'RECEIVER':
        addressString = 'receiver';
        break;
      case 'SHIPPER':
        addressString = 'shipper';
        break;
      case 'MOTHER_IMPORTER':
        addressString = 'importer';
        break;
      case 'BUYER':
        addressString = 'buyer';
        break;
      case 'SELLER':
        addressString = 'seller';
        break;
    }
    return addressString;
  }

  intialiseAddressFormGroup() {
    this.addressDetailsForm = this.fb.group({
      address_details: this.fb.group({
        CompanyName: new FormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(60)])
        ),
        ContactPersonName: new FormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(45)])
        ),
        AddressLine1: new FormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(45)])
        ),
        AddressLine2: new FormControl('', Validators.compose([Validators.maxLength(45)])),
        AddressLine3: new FormControl('', Validators.compose([Validators.maxLength(45)])),
        CityName: new FormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(35)])
        ),
        CountryName: new FormControl('', Validators.compose([Validators.maxLength(45)])),
        PostalCode: new FormControl('', Validators.compose([Validators.required])),
        CountryCode: new FormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.maxLength(2),
            Validators.minLength(2),
          ])
        ),
        suburb: new FormControl(
          '',
          Validators.compose([Validators.minLength(1), Validators.maxLength(45)])
        ),
        ProvinceCode: new FormControl(
          '',
          Validators.compose([Validators.minLength(1), Validators.maxLength(35)])
        ),
        Email: new FormControl('', Validators.compose([Validators.maxLength(50)])),
        NickName: new FormControl('', Validators.compose([Validators.maxLength(50)])),

        MobilePhone: new FormControl(
          '',
          Validators.compose([Validators.maxLength(25), Validators.pattern('[- +()0-9]+')])
        ),
        Phone: new FormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.minLength(1),
            Validators.maxLength(25),
            Validators.pattern('[- +()0-9]+'),
          ])
        ),
      }),
      preAlertEmails: this.fb.array([]),
      shipmentNotification: new FormControl(false),
      businessNotification: new FormControl(false),
      typeCode: new FormControl(''),
      _id: new FormControl(''),
      address_id: new FormControl(''),
      address_type: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  convertAddress() {
    this.addressDetailsForm
      .get('address_details')
      .get('CityName')
      .setValue(this.addressDetailsForm.get('address_details').get('CityName').value.toUpperCase());
    this.addressDetailsForm
      .get('address_details')
      .get('CountryName')
      .setValue(
        this.addressDetailsForm.get('address_details').get('CountryName').value.toUpperCase()
      );
    const addressFormValue = this.addressDetailsForm.getRawValue();
    const addressString = this.getAddressTypeString(
      this.addressDetailsForm.getRawValue().address_type
    );
    const keys = Object.keys(addressFormValue.address_details);
    const result = {};
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      result[addressString.concat(key)] = addressFormValue.address_details[key].trim();
    }
    addressFormValue.address_details = result;
    if (
      this.addressDetailsForm.getRawValue().address_type == 'SELLER' ||
      this.addressDetailsForm.getRawValue().address_type == 'BUYER'
    ) {
      addressFormValue.typeCode = addressFormValue.businessNotification
        ? 'business'
        : 'direct_consumer';
    }
    this.addressData = addressFormValue.address_details;
    return addressFormValue;
  }

  saveAddress() {
    if (this.formType === 'Update') {
      this.addressService.updateAddress(this.convertAddress(), this.addressUniqueId).subscribe({
        next: _data => {
          this.dialogRef.close({
            data: this.currentPageFrom,
            _addressType: _data.address_type,
            _addressID: _data.address_id,
            _id: _data._id,
          });
          this.snackBarService.createSnackBar(
            basicSnackBarConfig.addressComponentUpdate?.message,
            basicSnackBarConfig.addressComponentUpdate?.horizontalPosition,
            basicSnackBarConfig.addressComponentUpdate?.verticalPosition,
            basicSnackBarConfig.addressComponentUpdate?.duration
          );
        },
      });
    } else {
      const isBuyerOrSeller = this.addressDetailsForm.getRawValue().address_type;
      if (isBuyerOrSeller === 'SELLER' && this.data.sellerCount == 1) {
        this.errorDialogService.openDialog('shipment.lineItem.onlyOneByuerOrSeller', false);
        return;
      }
      if (isBuyerOrSeller === 'BUYER' && this.data.buyerCount == 1) {
        this.errorDialogService.openDialog('shipment.lineItem.onlyOneByuerOrSeller', false);
        return;
      }
      this.addressService.createAddress(this.convertAddress()).subscribe({
        next: _data => {
          this.dialogRef.close({
            data: this.currentPageFrom,
            _addressType: _data.address_type,
            _addressID: _data.address_id,
            _id: _data._id,
            _addressDetails: _data.address_details,
          });
          this.snackBarService.createSnackBar(
            basicSnackBarConfig.addressComponentSave?.message,
            basicSnackBarConfig.addressComponentSave?.horizontalPosition,
            basicSnackBarConfig.addressComponentSave?.verticalPosition,
            basicSnackBarConfig.addressComponentSave?.duration
          );
        },
      });
    }
  }

  selectionChanged(eventVal: string) {
    if (eventVal != '') {
      this.CountryCode = this.list.find(con => con.name === eventVal).code;
      this.addressDetailsForm.get('address_details').get('CountryCode').setValue(this.CountryCode);
      this.addressDetailsForm.get('address_details').get('PostalCode').setValue('');
      this.addressDetailsForm.get('address_details').get('CityName').setValue('');
      this.addressDetailsForm.get('address_details').get('suburb').setValue('');
      this.addressService
        .getPostalCodeServiceableArea(
          this.addressDetailsForm.get('address_details').get('CountryCode').value,
          '',
          ''
        )
        .subscribe((response: any) => {
          this.cityList = response?.postalLocationList;
        });
      this.isPostalCodeReq = this.list.find(
        con => con.code === this.CountryCode
      ).isPostalCodeServiceAvailable;
      if (!this.isPostalCodeReq) {
        this.addressDetailsForm.get('address_details').get('PostalCode').disable();
        this.isPostalCodeValid = true;
      } else {
        this.addressDetailsForm.get('address_details').get('PostalCode').enable();
      }
    } else {
      this.addressDetailsForm.get('address_details').get('CountryCode').setValue('');
    }
  }

  selectionCityChanged(event, item) {
    this.isAddressValidated = true;
    if (!item?.postalCode) {
      this.addressDetailsForm.get('address_details').get('PostalCode').disable();
      if (event.isUserInput) {
        if (item?.cityDistrict) {
          this.addressDetailsForm.get('address_details').get('suburb').setValue(item?.cityDistrict);
        }
      }
    } else {
      this.addressDetailsForm.get('address_details').get('PostalCode').enable();
      if (event.isUserInput) {
        this.addressDetailsForm.get('address_details').get('PostalCode').setValue(item?.postalCode);
      }
    }
  }

  selectionPincodeChanged(event, item) {
    this.isAddressValidated = true;
    if (event.isUserInput) {
      this.addressDetailsForm.get('address_details').get('CityName').setValue(item?.city);
      this.isCityValid = true;
    }
  }

  isPostalCodeCityValid() {
    return this.isPostalCodeValid && this.isCityValid && this.isAddressValidated;
  }

  defaultChange(event: MatSlideToggleChange) {
    if (event.checked) {
      const configData = {
        config_id: 'default_shipper_address',
        data: [{ address_id: this.addressID, _id: this.addressUniqueId }],
      };
      this.configService.saveConfig(configData).subscribe(() => {
        this.behaviourService.sendEvent(this.addressID);
        this.errorDialogService.openDialog('alert.defaultShipperSuccess', false);
        this.configService.putConfig(configData.config_id, configData.data);
      });
    } else {
      const reqBody = {
        body: {
          config_id: 'default_shipper_address',
          id: [this.addressUniqueId],
        },
      };
      this.configService.deleteConfig(reqBody).subscribe(() => {
        this.behaviourService.sendEvent('');
        this.errorDialogService.openDialog('alert.removedDefaultShipper', false);
        this.dexieDbService.deleteConfig('default_shipper_address');
      });
    }
  }

  preAlertEmails(): FormArray {
    return this.addressDetailsForm.get('preAlertEmails') as FormArray;
  }

  addressTypeChanged(addressValue) {
    if (addressValue === 'RECEIVER') {
      this.isReceiver = true;
    } else {
      this.isReceiver = false;
    }
    if (addressValue === 'SELLER') {
      this.addressDetailsForm.get('businessNotification')?.setValue(true);
    } else if (addressValue === 'BUYER') {
      this.addressDetailsForm.get('businessNotification')?.setValue(false);
    }
  }

  newPreAlertMsg(): FormGroup {
    return this.fb.group({
      typeCode: 'email',
      receiverId: '',
      bespokeMessage: '',
    });
  }

  patchPreAlertNew(preAlertEmailsData) {
    if (preAlertEmailsData.length > 0) {
      (this.addressDetailsForm.get('preAlertEmails') as FormArray).clear();
      preAlertEmailsData.forEach(alertMsg => {
        const alertMsgGrp = this.newPreAlertMsg();
        alertMsgGrp.patchValue(alertMsg);
        (this.addressDetailsForm.get('preAlertEmails') as FormArray).push(alertMsgGrp);
      });
    } else {
      (this.addressDetailsForm.get('preAlertEmails') as FormArray).clear();
    }
  }

  openPreAlertSetting() {
    const shipmentDetailsCreateDialogRef = this.dialog.open(AddressEmailAlertComponent, {
      maxHeight: '60vh',
      maxWidth: '60vw',
      data: {
        openedFrom: 'receiverAddress',
        preAlertEmails: this.addressDetailsForm.get('preAlertEmails').value,
        shipmentForm: this.addressDetailsForm,
        receiverAddress: this.convertAddress(),
      },
    });
    shipmentDetailsCreateDialogRef
      .afterClosed()
      .subscribe(result => this.patchPreAlertNew(result?.value));
  }

  showHideEmailAdd(checked: boolean) {
    let preAlertEmailsData = [];

    if (checked) {
      // When checked, populate preAlertEmails if empty
      if (this.addressDetailsForm.get('preAlertEmails').value.length < 1) {
        const receiverEmail = this.addressDetailsForm.value.address_details.Email;
        this.addressDetailsForm.get('shipmentNotification').setValue(checked);
        // Convert single email string to array format if it exists
        if (receiverEmail && receiverEmail.trim()) {
          preAlertEmailsData = [
            {
              typeCode: 'email',
              receiverId: receiverEmail,
              bespokeMessage: '',
            },
          ];
          this.patchPreAlertNew(preAlertEmailsData);
        }
      }
    } else {
      // When unchecked, clear preAlertEmails
      this.patchPreAlertNew([]);
    }

    checked ? (this.showEmailAdd = true) : (this.showEmailAdd = false);
  }

  businessNotificationClicked(checked: boolean) {
    if (!checked && this.businessTypeVal === 'SELLER') {
      this.errorDialogService.openDialog(
        'address.createAddress.businessNotificationMessage',
        false
      );
    }
  }
}
